import { UseInteractiveSimulationModeSelector } from "./useInteractiveSimulationModeSelector";
import { CarMultiSelect } from "@app/components/MulitSelect";
import { CarSelectOption, CarSelectOptionGroup } from "@app/components/Inputs";
import { BoxProps } from "@mui/material";

export const InteractiveSimulationModeSelector = (props: {
  sx?: BoxProps["sx"];
  selector: UseInteractiveSimulationModeSelector;
}) => {
  return (
    <CarMultiSelect
      sx={{
        width: 270,
        ".MuiInputBase-root": {
          backgroundColor: "white",
        },
        ".MuiInputLabel-root": {
          fontSize: "16px",
        },
        ...props.sx,
      }}
      label="Interactive Simulation Mode"
      value={props.selector.statRowIds}
      onChange={props.selector.setStatRowIds}
      groups={props.selector.statGroups.map<CarSelectOptionGroup<string>>(
        (g) => ({
          label: g.label,
          items: g.rows.map<CarSelectOption<string>>((i) => ({
            value: i.id,
            label: i.name,
          })),
        }),
      )}
    />
  );
};
